<script setup lang="ts">
import type { HTMLAttributes } from 'vue'

const props = withDefaults(
  defineProps<{
    duration?: number
    throttle?: number
    hideDelay?: number
    resetDelay?: number
    class?: HTMLAttributes['class']
    estimatedProgress?: (duration: number, elapsed: number) => number
  }>(),
  {
    duration: 3000,
    throttle: 100,
    hideDelay: 500,
    resetDelay: 1000,
    class: undefined,
    estimatedProgress: undefined
  }
)

const { progress, isLoading, error, start, finish, clear } =
  useLoadingIndicator({
    duration: props.duration,
    throttle: props.throttle,
    hideDelay: props.hideDelay,
    resetDelay: props.resetDelay,
    estimatedProgress: props.estimatedProgress
  })

defineExpose({
  progress,
  isLoading,
  error,
  start,
  finish,
  clear
})
</script>
<template>
  <div
    v-if="isLoading"
    :class="
      cn(
        'fixed left-0 right-0 bg-primary z-999 h-0.5 transition-all',
        props.class
      )
    "
    :style="{
      width: `${progress}%`
    }"
  ></div>
</template>
